module.exports = __webpack_public_path__ + "assets/img/safe_1.15acfa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/safe_1.jpg
// module id = Z6n5
// module chunks = 0